import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'
import {
  fetchParentStudents,
  getActiveStudentId
} from '../../lib/parentStudents'

export default function ParentGrades() {
  const [grades, setGrades] = useState([])
  const [student, setStudent] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchData() {
      const { data: { user } } = await supabase.auth.getUser()

      if (!user) {
        setLoading(false)
        return
      }

      const { students } =
        await fetchParentStudents(user.id)

      const activeId =
        getActiveStudentId(students)

      const activeStudent =
        students.find(s => s.id === activeId)

      if (!activeStudent) {
        setLoading(false)
        return
      }

      setStudent(activeStudent)

      const { data } = await supabase
        .from('grades')
        .select('*')
        .eq('student_id', activeStudent.id)
        .order('created_at', {
          ascending: false
        })

      setGrades(data || [])
      setLoading(false)
    }

    fetchData()

    window.addEventListener(
      'parent-student-changed',
      fetchData
    )

    return () => {
      window.removeEventListener(
        'parent-student-changed',
        fetchData
      )
    }
  }, [])

  const pct = (s, t) =>
    Math.round(s / t * 100)

  const pctClass = p =>
    p >= 80
      ? 'badge-success'
      : p >= 60
        ? 'badge-warning'
        : 'badge-danger'

  if (loading) {
    return <div className="empty">Loading...</div>
  }

  return (
    <div>
      <h2 style={{
        fontSize: 20,
        fontWeight: 500,
        marginBottom: 8
      }}>
        My Grades
      </h2>

      {student && (
        <div style={{
          fontSize: 13,
          color: 'var(--text3)',
          marginBottom: 20
        }}>
          Showing grades for{' '}
          <strong style={{ color: 'var(--text2)' }}>
            {student.name}
          </strong>
        </div>
      )}

      {grades.length === 0 ? (
        <div className="empty">
          No grades yet
        </div>
      ) : (
        <div
          className="card"
          style={{
            padding: 0,
            overflow: 'hidden'
          }}
        >
          <table>
            <thead>
              <tr>
                <th>Exam</th>
                <th>Date</th>
                <th>Score</th>
                <th>%</th>
                <th>Note</th>
              </tr>
            </thead>

            <tbody>
              {grades.map(g => {
                const p = pct(g.score, g.total)

                return (
                  <tr key={g.id}>
                    <td style={{ fontWeight: 500 }}>
                      {g.exam_name}
                    </td>

                    <td style={{
                      color: 'var(--text3)'
                    }}>
                      {g.exam_date || '—'}
                    </td>

                    <td>
                      {g.score}/{g.total}
                    </td>

                    <td>
                      <span className={`badge ${pctClass(p)}`}>
                        {p}%
                      </span>
                    </td>

                    <td style={{
                      color: 'var(--text3)'
                    }}>
                      {g.note || '—'}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}